import { themeVars } from '../theme/vars.ts';
import { space } from '../tokens.ts';
import { style, styleVariants } from '../layer.css';

export const avatarSizesPx = {
  xs: 24,
  small: 32,
  xm: 40,
  medium: 48,
  large: 80,
  xl: 120,
} as const;
export type AvatarSize = keyof typeof avatarSizesPx;

const getSize = (size: AvatarSize) => ({
  width: avatarSizesPx[size],
  height: avatarSizesPx[size],
});

export const avatarRootSize = styleVariants({
  xs: getSize('xs'),
  small: getSize('small'),
  xm: getSize('xm'),
  medium: getSize('medium'),
  large: getSize('large'),
  xl: getSize('xl'),
});

export const avatarRoot = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  verticalAlign: 'middle',
  overflow: 'hidden',
  userSelect: 'none',
  padding: space.s3,
  flexShrink: 0,
  borderRadius: '100%',
});

export const avatarImage = style({
  objectFit: 'cover',
  height: '100%',
  width: '100%',
  borderRadius: 'inherit',
});

export const avatarFallback = style({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: themeVars.container.tertiary.background.idle,
  color: themeVars.container.foreground.primary,
  borderRadius: 'inherit',
  padding: '22%',
});
